import globalAxios from 'axios';
import { assertParamExists, DUMMY_BASE_URL, setApiKeyToObject, setSearchParams, toPathString, createRequestFunction } from '../common.js';
import { operationServerMap, BaseAPI, BASE_PATH } from '../base.js';

/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * MediaSegmentsApi - axios parameter creator
 * @export
 */
const MediaSegmentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all media segments based on an itemId.
         * @param {string} itemId The ItemId.
         * @param {Array<MediaSegmentType>} [includeSegmentTypes] Optional filter of requested segment types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemSegments: async (itemId, includeSegmentTypes, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('getItemSegments', 'itemId', itemId);
            const localVarPath = `/MediaSegments/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (includeSegmentTypes) {
                localVarQueryParameter['includeSegmentTypes'] = includeSegmentTypes;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MediaSegmentsApi - functional programming interface
 * @export
 */
const MediaSegmentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MediaSegmentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets all media segments based on an itemId.
         * @param {string} itemId The ItemId.
         * @param {Array<MediaSegmentType>} [includeSegmentTypes] Optional filter of requested segment types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemSegments(itemId, includeSegmentTypes, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemSegments(itemId, includeSegmentTypes, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MediaSegmentsApi.getItemSegments']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * MediaSegmentsApi - factory interface
 * @export
 */
const MediaSegmentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MediaSegmentsApiFp(configuration);
    return {
        /**
         *
         * @summary Gets all media segments based on an itemId.
         * @param {MediaSegmentsApiGetItemSegmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemSegments(requestParameters, options) {
            return localVarFp.getItemSegments(requestParameters.itemId, requestParameters.includeSegmentTypes, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MediaSegmentsApi - object-oriented interface
 * @export
 * @class MediaSegmentsApi
 * @extends {BaseAPI}
 */
class MediaSegmentsApi extends BaseAPI {
    /**
     *
     * @summary Gets all media segments based on an itemId.
     * @param {MediaSegmentsApiGetItemSegmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaSegmentsApi
     */
    getItemSegments(requestParameters, options) {
        return MediaSegmentsApiFp(this.configuration).getItemSegments(requestParameters.itemId, requestParameters.includeSegmentTypes, options).then((request) => request(this.axios, this.basePath));
    }
}

export { MediaSegmentsApi, MediaSegmentsApiAxiosParamCreator, MediaSegmentsApiFactory, MediaSegmentsApiFp };
